import { SectionContainerTypes } from '@genial/components';
import { Dimensions, DimensionValue } from 'react-native';

export const maxHeight = 504;
export const maxHeightMobile = `${
  Dimensions.get('window').height - Dimensions.get('window').height * 0.25
}px` as DimensionValue;

export const rowHeight = 74;
export const columnWidthsCheckingAccount = {
  date: 10,
  client: 40,
  value: 20,
  kind: 20,
};
export const columnWidthsPendingRedemption = {
  date: 10,
  client: 25,
  product: 25,
  value: 20,
  balance: 20,
};

export const columnWidthsFutureMaturities = {
  date: 10,
  client: 30,
  product: 35,
  value: 20,
};

export const tableHeaders = {
  CurrentAccount: [
    { key: 'date', label: 'Data', align: 'left' },
    { key: 'client', label: 'Cliente', align: 'left' },
    { key: 'kind', label: 'Tipo', align: 'center' },
    { key: 'value', label: 'Valor(R$)', align: 'center' },
  ],
  WithdrawnToBeSettled: [
    { key: 'date', label: 'Data', align: 'left' },
    { key: 'client', label: 'Cliente', align: 'left' },
    { key: 'product', label: 'Produto', align: 'left' },
    { key: 'value', label: 'Valor(R$)', align: 'center' },
    { key: 'balance', label: 'Saldo(R$)', align: 'center' },
  ],
  FutureMaturities: [
    { key: 'date', label: 'Data', align: 'left' },
    { key: 'client', label: 'Cliente', align: 'left' },
    { key: 'product', label: 'Produto', align: 'left' },
    { key: 'value', label: 'Valor(R$)', align: 'center' },
  ],
};

export const buttons = [
  { label: 'Conta corrente', key: 'CurrentAccount' },
  { label: 'Resgates a liquidar', key: 'WithdrawnToBeSettled' },
  { label: 'Vencimentos Futuros', key: 'FutureMaturities' },
];

export const summaryOptions: SectionContainerTypes.FilterOption[] = [
  {
    label: 'CONTA CORRENTE',
    value: 'CurrentAccount',
  },
  {
    label: 'RESGATES A LIQUIDAR',
    value: 'WithdrawnToBeSettled',
  },
  {
    label: 'VENCIMENTOS FUTUROS',
    value: 'FutureMaturities',
  },
];

export const periodOptions: SectionContainerTypes.FilterOption[] = [
  {
    label: 'PRÓXIMOS 30 DIAS',
    value: 'next',
  },
  {
    label: 'ÚLTIMOS 30 DIAS',
    value: 'prev',
  },
];
